import React, { useState } from "react";
import emailjs from "emailjs-com";
import styled from "styled-components";

const ContactForm = () => {
  const [formValues, setFormValues] = useState({
    user_name: "",
    user_email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_z9325oq",
        "template_0yyyugx",
        e.target,
        "7vkjif-MYv_kfcrQI"
      )
      .then(
        (result) => {
          alert("Message sent successfully!");
        },
        (error) => {
          alert("Failed to send the message, please try again.");
        }
      );
  };

  return (
    <Container>
      <Wrap>
        <form onSubmit={handleSubmit}>
          <h4>Name:</h4>
          <div className="input-container">
            <input
              className="input"
              type="text"
              name="user_name"
              value={formValues.user_name}
              onChange={handleChange}
              required
            />
            <label className="label" htmlFor="input">
              Enter Your Name
            </label>
            <div className="topline"></div>
            <div className="underline"></div>
          </div>
          <Margin />

          <h4>Email:</h4>
          <div className="input-container">
            <input
              className="input"
              type="text"
              name="user_email"
              value={formValues.user_email}
              onChange={handleChange}
              required
            />
            <label className="label" htmlFor="input">
              Enter Your Email
            </label>
            <div className="topline"></div>
            <div className="underline"></div>
          </div>
          <Margin />

          <h4>Message:</h4>
          <div className="input-container">
            <input
              type="text"
              className="input"
              name="message"
              value={formValues.message}
              onChange={handleChange}
              required
            />
            <label className="label" htmlFor="input">
              Enter Your Message
            </label>
            <div className="topline"></div>
            <div className="underline"></div>
          </div>
          <Margin />

          <button type="submit" className="button">
            <p className="text">Send</p>
            <span className="icon">
              <svg
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                data-icon="paper-plane"
                width="20px"
                aria-hidden="true"
              >
                <path
                  d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </button>
        </form>
      </Wrap>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .input-container {
    position: relative;
    margin: 20px 0;
    width: 100%;

    @media only screen and (max-width: 768px) {
      margin: 15px 0;
    }
  }

  .input {
    width: 100%;
    padding: 10px;
    height: 40px;
    border: 2px solid var(--secondary-color);
    border-top: none;
    border-bottom: none;
    font-size: 16px;
    background: transparent;
    outline: none;
    box-shadow: 7px 7px 0px 0px var(--secondary-color);
    transition: all 0.5s;

    @media only screen and (max-width: 1024px) {
      padding: 8px;
      font-size: 15px;
    }

    @media only screen and (max-width: 768px) {
      padding: 6px;
      font-size: 14px;
    }
  }

  .input:focus {
    box-shadow: none;
    transition: all 0.5s;
  }

  .label {
    position: absolute;
    top: 10px;
    left: 10px;
    color: var(--secondary-color);
    transition: all 0.5s;
    transform: scale(0);
    z-index: -1;
  }

  .input-container .topline,
  .input-container .underline {
    position: absolute;
    content: "";
    background-color: var(--secondary-color);
    width: 0%;
    height: 2px;
    right: 0;
    transition: all 0.5s;
  }

  .input-container .topline {
    top: 0;
  }

  .input-container .underline {
    bottom: 0;
  }

  .input-container input[type="text"]:focus ~ .topline {
    width: 35%;
    transition: all 0.5s;
  }

  .input-container input[type="text"]:focus ~ .underline {
    width: 100%;
    transition: all 0.5s;
  }

  .input-container input[type="text"]:focus ~ .label {
    top: -10px;
    transform: scale(1);
    transition: all 0.5s;
  }
`;

const Wrap = styled.div`
  width: 60%;
  padding: 30px 0;

  @media only screen and (max-width: 1024px) {
    width: 80%;
    padding: 20px 0;
  }

  @media only screen and (max-width: 768px) {
    width: 90%;
    padding: 15px 0;
  }
`;

const Margin = styled.div`
  width: 100%;
  height: 50px;

  @media only screen and (max-width: 768px) {
    height: 30px;
  }
`;

export default ContactForm;
